<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>“We haven’t had anyone to play with in a while.”</p>
<p>“We’ve been here by ourselves for longer.”</p>
<p>“But I’m bored. I want someone to play with.”</p>
<p>“Even when someone is here, you are still bored. You’ll be fine.”</p>
<p>“You keep chasing them off. The last people that came weren’t here very long and you chased them off.”</p>
<p>“I didn’t like playing with them.”</p>
<p>“You didn’t know them.”</p>
<p>“As long as I’ve been around and as many people as I’ve seen come and go, I know which ones I’m going to like and which ones I won’t.”</p>
<p>“I should get to choose too.”</p>
<p>“Fine. You can deal with anyone you don’t like. I will deal with the ones I don’t.”</p>
<p>The abandoned old farmhouse had witnessed thousands upon thousands of these wordless exchanges through the years. Maybe it sat idle because there was never a resolution, or maybe it sat idle simply because the conversation existed. Either way, the farmhouse was the only thing that had no say in who lived there, though the former residents and prospective buyers would give a much different story.</p>
<p>The house had a way of “coming to life”. Small items would come up missing. Faucets would turn on or off all by themselves. Items flying through the air, or ending up in places they were not left, were a common occurrence. Local real estate agents dreaded this house. They dreaded seeing it listed, they dreaded showing it, they simply dreaded everything about the house.</p>
<p>Stories were rampant among the agents of disastrous showings, of terrified buyers on the other end of their phones at odd hours of the night. Though there was speculation as to what caused the events at this house, that was all there was. Speculation. Rumors grew and spread, changing with every new listing of the house. From an overflowing sink that almost electrocuted a newlywed couple at a showing, to even darker stories about an agent heading to a showing never to be seen of again.</p>
<p>It had gotten to where most agents would find some sort of excuse why not to enter the house, always “getting a phone call” to “having made a scheduling conflict” that would result in them welcoming the latest tour to be self-guided as the agent would locate themselves anywhere other than the interior of that house.</p>
<p>No one in the local community would dream of buying that house, as the stories had escaped the real estate community into the population as a whole. This created an interesting scenario for all the locals. One, you knew that anyone moving in that house wasn’t from “around here”. Two, you knew they weren’t going to stay long. Three, they were going to have it listed for way too much money trying to recoup their investment.</p>
<p>There had been talk of bulldozing the house, but no one wanted to foot the bill for the excavating cost. So, the house stayed. Empty. Keeping track of the passing of time as well as a calendar with each passing resident.</p>
<p>Hope for it ever selling again had almost totally waned. No one had inquired about it for quite some time, much less actually looked at it.</p>
<p>“Here comes someone.”</p>
<p>“I know.”</p>
<p>A taller than average man, well-groomed with sandy blonde hair, worked the key around a bit before the lock would yield. The creaking door was the only welcome party, as the man walked in alone. His eyes jumped up and down walls, across the floor, then led him further into the house.</p>
<p>“I don’t like him.”</p>
<p>“Why not?”</p>
<p>“I just don’t like him.”</p>
<p>“It needs some work,” the man said aloud to himself, “but this could be home. It just needs a little care. How long has it been since anyone showed you some love and affection?” The question seemed to be asked to the house itself.</p>
<p>“He seems nice. I like him.”</p>
<p>“I’m going to go have some fun with him, see what he’s made of.”</p>
<p>“Please don’t.”</p>
<p>“Why not?”</p>
<p>“I want to play with him.”</p>
<p>“So?”</p>
<p>“How about this? You give him a chance, let me have some fun with him. If you don’t like him, then I will help you deal with him in the grandest of ways.”</p>
<p>“Deal.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?346795cd